import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Material } from 'src/app/core/material';
import { MaterialService } from 'src/app/services/material/material.service';
import { ComboMaterial } from '../../../../core/combo-material';
import { MaterialPlanejamentoOficina } from '../../../../core/materiais-planejamento-oficina';
import { PlanejamentoOficina } from '../../../../core/planejamento-oficina';
import { DataUtilService } from "../../../../services/commons/data-util.service";

@Component({
    selector: 'cadastrar-materiais',
    templateUrl: './cadastrar-materiais.component.html',
    styleUrls: ['./cadastrar-materiais.component.css']
})
export class CadastrarMateriaisComponent implements OnInit {

    @Input() planejamentoOficina: PlanejamentoOficina;
    materialPlanejamentoOficina: MaterialPlanejamentoOficina;
    comboMaterialSelecionado: ComboMaterial;
    listaDeMateriais: Material[] = [];

    isAtualizar = false;
    isMostrarFuncionario = false;

    formasPagamento = [
        {tipo: 'D', descricao: 'Dinheiro'},
        {tipo: 'C', descricao: 'Cartão'},
        {tipo: 'D', descricao: 'Débito'},
        {tipo: 'F', descricao: 'Desconto em folha'},
    ];

    constructor(
        private materialService: MaterialService,
        private dataUtilService: DataUtilService
    ) {
    }

    ngOnInit() {
        this.zerarCombos();
        this.materialService.getAll().subscribe((materiais: Material[]) => {
            this.listaDeMateriais = materiais;
            if (this.listaDeMateriais && this.listaDeMateriais.length > 0) {
                this.montarComboMaterial(this.listaDeMateriais[0].id);
            }
        });
    }


    zerarCombos() {
        this.materialPlanejamentoOficina = new MaterialPlanejamentoOficina();
        this.materialPlanejamentoOficina.material = new Material();
        this.isMostrarFuncionario = false;
    }

    adicionar() {
        this.montarMaterial(this.comboMaterialSelecionado.id);
        const materialPlanejamentoOficina = new MaterialPlanejamentoOficina();
        Object.assign(materialPlanejamentoOficina, this.materialPlanejamentoOficina);
        if (!this.planejamentoOficina.materiaisPlanejamentosOficinas) {
            this.planejamentoOficina.materiaisPlanejamentosOficinas = [];
        }
        this.planejamentoOficina.materiaisPlanejamentosOficinas.push(materialPlanejamentoOficina);
        this.zerarCombos();
    }


    montarMaterial(idMaterial: number) {
        this.materialPlanejamentoOficina.material = _.cloneDeep(_.find(this.listaDeMateriais, (m: Material) => m.id === idMaterial));
    }

    atualizar() {
        const index = this.planejamentoOficina.materiaisPlanejamentosOficinas.indexOf(this.planejamentoOficina.materiaisPlanejamentosOficinas.find(col => col.id === this.materialPlanejamentoOficina.id));
        this.planejamentoOficina.materiaisPlanejamentosOficinas.splice(index, 1, this.materialPlanejamentoOficina);
        this.isAtualizar = false;
        this.zerarCombos();
    }

    atualizarMaterial(materialPlanejamentoOficina: MaterialPlanejamentoOficina) {
        if (materialPlanejamentoOficina && materialPlanejamentoOficina.material && materialPlanejamentoOficina.material.id) {
            this.montarComboMaterial(materialPlanejamentoOficina.material.id);
        }
        this.isAtualizar = true;
        this.materialPlanejamentoOficina = materialPlanejamentoOficina;
    }

    cancelar() {
        this.zerarCombos();
        this.isAtualizar = false;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onValorChangeMaterial(registro: any) {
        if (registro && registro.id) {
            this.montarMaterial(registro.id);
            this.montarComboMaterial(registro.id);
        }
    }

    montarComboMaterial(id: number) {
        this.listaDeMateriais.forEach(m => {
            if (m.id == id) {
                this.comboMaterialSelecionado = { id: m.id, nome: m.nome };
            }
        });
    }

}
